module.exports = __webpack_public_path__ + "officialStatic/img/qdnyLogo.ebd06d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/qdnyLogo.png
// module id = p8e5
// module chunks = 0